<template>
    <ElPopover
        v-bind="$attrs"
        :trigger="trigger"
        :width="width">
        <template #reference>
            <slot name="reference" />
        </template>
        <template #default>
            <slot>
                <font-awesome-icon
                    class="pointer"
                    fixed-width
                    :icon="icon"
                    @click="$emit('click', $event)" />
            </slot>
        </template>
    </ElPopover>
</template>

<script>

export default {
    name: "BasePopover",
    props: {
        icon: {
            type: String,
            default: "circle-info"
        },
        width: {
            type: String,
            default: "300"
        },
        trigger: {
            type: String,
            default: "hover"
        }
    },
}
</script>

<style scoped>

</style>
